export default __webpack_public_path__ + "static/example-golf-guide-4fe189b4448b60fe90be0b32ce59632e.svg";